import React from 'react';

const COLORS = ['#818cf8','#34d399','#f59e0b','#60a5fa','#f472b6','#a78bfa'];

export function MetricsCard({ title = 'Métricas', items = [] }) {
  return (
    <div style={{ margin: '10px 0 14px', padding: '14px 16px', background: 'rgba(6,14,40,0.55)', border: '1px solid rgba(56,189,248,0.12)', borderRadius: 12, fontFamily: 'inherit' }}>
      <span style={{ fontSize: 9.5, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(56,189,248,0.55)', display: 'block', marginBottom: 12 }}>
        {title}
      </span>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {items.map((item, i) => {
          const color = item.color || COLORS[i % COLORS.length];
          const pct = Math.min(100, Math.max(0, item.value || 0));
          return (
            <div key={i}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                <span style={{ fontSize: 11.5, color: 'rgba(172,196,236,0.7)', letterSpacing: '.02em' }}>{item.label}</span>
                <span style={{ fontSize: 11.5, color, fontWeight: 600 }}>{pct}%</span>
              </div>
              <div style={{ height: 4, background: 'rgba(255,255,255,0.06)', borderRadius: 2, overflow: 'hidden' }}>
                <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: 2, transition: 'width .8s ease' }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
